import type { IntlShape } from 'react-intl'
import type {
	MeterInvoicingInput,
	MeterInvoicePaymentProductHeader,
	MeterInvoicingDraft,
	MeterInvoicingRowsByContract,
} from './types'

export const meterInvoiceBasicInformationInputs: MeterInvoicingInput[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Selite / erillislaskun väliotsikko',
				description: 'Description / subheading',
			}),
		key: 'description',
		show: true,
		type: 'text',
		fullWidth: true,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Laskupäivä',
				description: 'Invoice date',
			}),
		key: 'invoiceDate',
		show: true,
		type: 'date',
		fullWidth: true,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Eräpäivä',
				description: 'Due date',
			}),
		key: 'dueDate',
		show: true,
		type: 'date',
		fullWidth: true,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Laskutusjakso alkupäivä',
				description: 'Invoice period start date',
			}),
		key: 'invoicePeriodStartDate',
		show: true,
		type: 'date',
		fullWidth: false,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Laskutusjakso loppupäivä',
				description: 'Invoice period end date',
			}),
		key: 'invoicePeriodEndDate',
		show: true,
		type: 'date',
		fullWidth: false,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Saateteksti laskulle',
				description: 'Invoice text',
			}),
		key: 'additionalInformation',
		show: true,
		type: 'text',
		fullWidth: true,
	},
]

export const meterInvoicePaymentProductHeaders: MeterInvoicePaymentProductHeader[] =
	[
		{
			title: (intl: IntlShape) =>
				intl.formatMessage({
					defaultMessage: 'Maksulaji',
					description: 'Payment product',
				}),
			key: 'name',
		},
		{
			title: (intl: IntlShape) =>
				intl.formatMessage({
					defaultMessage: 'Mittarin tyyppi',
					description: 'Meter type',
				}),
			key: 'meterType',
		},
		{
			title: (intl: IntlShape) =>
				intl.formatMessage({
					defaultMessage: 'Laskutustyyppi',
					description: 'Meter billing type',
				}),
			key: 'meterBillingType',
		},
		{
			title: (intl: IntlShape) =>
				intl.formatMessage({
					defaultMessage: 'Hinta',
					description: 'Price',
				}),
			key: 'priceWithVat',
		},
		{
			title: (intl: IntlShape) =>
				intl.formatMessage({
					defaultMessage: 'Veloitusperuste',
					description: 'Billing basis',
				}),
			key: 'billingBasis',
		},
	]

export const invoicePaymentProductsHeaders = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Nimike',
				description: 'Table header for invoice payment product name.',
			}),
		key: 'name',
		show: true,
		type: 'text',
		editable: false,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Hinta',
				description: 'Table header for invoice payment product price.',
			}),
		key: 'price',
		show: true,
		type: 'price',
		editable: false,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Hinta + alv',
				description: 'Table header for invoice payment product price with vat.',
			}),
		key: 'priceWithVat',
		show: true,
		type: 'priceWithVat',
		editable: false,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Määrä',
				description: 'Table header for invoice payment product amount.',
			}),
		key: 'quantity',
		show: true,
		type: 'number',
		editable: false,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Veloitusperuste',
				description: 'Table header for invoice payment product billing basis.',
			}),
		key: 'billingBasis',
		show: true,
		type: 'billingBasis',
		editable: false,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Yksikkö',
				description: 'Table header for invoice payment product unit.',
			}),
		key: 'unitMessage',
		show: true,
		type: 'unitMessage',
		editable: false,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Summa',
				description: 'Table header for invoice payment product total.',
			}),
		key: 'total',
		show: true,
		type: 'total',
		editable: false,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Summa + alv',
				description: 'Table header for invoice payment product total with vat.',
			}),
		key: 'totalWithVat',
		show: true,
		type: 'totalWithVat',
		editable: false,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Selite',
				description: 'Table header for invoice payment product total with vat.',
			}),
		key: 'description',
		show: true,
		type: 'text',
		editable: false,
	},
]

export const meterInvoicingDefaultValues: MeterInvoicingDraft = {
	companyUUID: '',
	description: '',
	invoiceDate: '',
	dueDate: '',
	invoicePeriodStartDate: '',
	invoicePeriodEndDate: '',
	additionalInformation: '',

	paymentProductUUIDs: [] as string[],
	contractUUIDs: [] as string[],

	meterInvoicingRowsByContract: [] as MeterInvoicingRowsByContract[],
}
